export default __webpack_public_path__ + "static/media/ma.1d94e2a5.jpg";